import '../pages/AdminPages.css';

const renderBlocks = (count, className) =>
  Array.from({ length: count }, (_, index) => (
    <div key={`${className}-${index}`} className={className} />
  ));

const AdminPageSkeleton = ({
  title = 'Načítavam',
  subtitle = 'Pripravujem obsah stránky',
  variant = 'table',
  showAction = true
}) => {
  const renderDashboardKpiCards = () =>
    Array.from({ length: 4 }, (_, index) => (
      <div key={`dashboard-kpi-${index}`} className="kpi-card admin-dashboard-skeleton-kpi-card">
        <div className="admin-dashboard-skeleton-kpi-label" />
        <div className="admin-dashboard-skeleton-kpi-value" />
        <div className="admin-dashboard-skeleton-kpi-trend">
          <div className="admin-dashboard-skeleton-kpi-icon" />
          <div className="admin-dashboard-skeleton-kpi-text" />
        </div>
      </div>
    ));

  const renderDashboardStatItems = () =>
    Array.from({ length: 8 }, (_, index) => (
      <div key={`dashboard-stat-${index}`} className="stat-item admin-dashboard-skeleton-stat-item">
        <div className="admin-dashboard-skeleton-stat-label" />
        <div className="admin-dashboard-skeleton-stat-value" />
      </div>
    ));

  const renderDashboardTimelineItems = (rows = 4) =>
    Array.from({ length: rows }, (_, index) => (
      <div key={`dashboard-timeline-${index}`} className="admin-dashboard-skeleton-timeline-row">
        <div className="admin-dashboard-skeleton-timeline-time" />
        <div className="admin-dashboard-skeleton-timeline-dot" />
        <div className="admin-dashboard-skeleton-timeline-card" />
      </div>
    ));

  const renderDashboardActivityItems = (rows = 5) =>
    Array.from({ length: rows }, (_, index) => (
      <div key={`dashboard-activity-${index}`} className="admin-dashboard-skeleton-activity-row">
        <div className="admin-dashboard-skeleton-activity-icon" />
        <div className="admin-dashboard-skeleton-activity-content">
          <div className="admin-dashboard-skeleton-activity-line" />
          <div className="admin-dashboard-skeleton-activity-time" />
        </div>
      </div>
    ));

  const renderServiceRows = (rows = 4) =>
    Array.from({ length: rows }, (_, index) => (
      <div key={`service-row-${index}`} className="service-row admin-skeleton-service-row">
        <div className="admin-skeleton-service-handle" />
        <div className="service-info admin-skeleton-service-info">
          <div className="admin-skeleton-service-title" />
          <div className="admin-skeleton-service-desc" />
        </div>
        <div className="admin-skeleton-service-meta" />
        <div className="admin-skeleton-service-meta admin-skeleton-service-meta-price" />
        <div className="admin-skeleton-service-toggle" />
        <div className="admin-skeleton-service-actions">
          <div className="admin-skeleton-service-action" />
          <div className="admin-skeleton-service-action" />
        </div>
      </div>
    ));

  const renderUserRows = (rows = 5) =>
    Array.from({ length: rows }, (_, index) => (
      <div key={`user-row-${index}`} className="admin-skeleton-user-row">
        <div className="admin-skeleton-user-avatar" />
        <div className="admin-skeleton-user-primary">
          <div className="admin-skeleton-user-name" />
          <div className="admin-skeleton-user-email" />
        </div>
        <div className="admin-skeleton-user-login" />
        <div className="admin-skeleton-user-badge" />
        <div className="admin-skeleton-user-badge" />
        <div className="admin-skeleton-user-date" />
        <div className="admin-skeleton-user-date" />
        <div className="admin-skeleton-user-date" />
        <div className="admin-skeleton-user-action" />
      </div>
    ));

  const renderReservationRows = (rows = 5) =>
    Array.from({ length: rows }, (_, index) => (
      <div key={`reservation-row-${index}`} className="admin-skeleton-reservation-row">
        <div className="admin-skeleton-reservation-checkbox" />
        <div className="admin-skeleton-reservation-date">
          <div className="admin-skeleton-reservation-date-line" />
          <div className="admin-skeleton-reservation-time-line" />
        </div>
        <div className="admin-skeleton-reservation-customer">
          <div className="admin-skeleton-reservation-name" />
          <div className="admin-skeleton-reservation-email" />
        </div>
        <div className="admin-skeleton-reservation-service" />
        <div className="admin-skeleton-reservation-badge" />
        <div className="admin-skeleton-reservation-phone" />
        <div className="admin-skeleton-reservation-created" />
        <div className="admin-skeleton-reservation-action" />
      </div>
    ));

  const renderGalleryRows = (rows = 4) =>
    Array.from({ length: rows }, (_, index) => (
      <div key={`gallery-row-${index}`} className="admin-skeleton-gallery-row">
        <div className="admin-skeleton-gallery-preview" />
        <div className="admin-skeleton-gallery-name" />
        <div className="admin-skeleton-gallery-size" />
        <div className="admin-skeleton-gallery-date" />
        <div className="admin-skeleton-gallery-action" />
      </div>
    ));

  const renderTableRows = (rows = 6) =>
    Array.from({ length: rows }, (_, index) => (
      <div key={`row-${index}`} className="admin-skeleton-table-row">
        <div className="admin-skeleton-cell admin-skeleton-cell-sm" />
        <div className="admin-skeleton-cell admin-skeleton-cell-md" />
        <div className="admin-skeleton-cell admin-skeleton-cell-md" />
        <div className="admin-skeleton-cell admin-skeleton-cell-sm" />
        <div className="admin-skeleton-cell admin-skeleton-cell-sm" />
      </div>
    ));

  const renderVariant = () => {
    switch (variant) {
      case 'dashboard':
        return (
          <>
            <div className="kpi-grid admin-dashboard-skeleton-kpi-grid">
              {renderDashboardKpiCards()}
            </div>
            <div className="dashboard-content admin-dashboard-skeleton-content">
              <div className="dashboard-main">
                <div className="stats-card admin-dashboard-skeleton-card month-stats">
                  <div className="admin-dashboard-skeleton-card-title" />
                  <div className="stats-grid-4x2">
                    {renderDashboardStatItems()}
                  </div>
                </div>

                <div className="stats-card admin-dashboard-skeleton-card today-schedule">
                  <div className="card-header-flex">
                    <div className="admin-dashboard-skeleton-card-title" />
                    <div className="admin-dashboard-skeleton-card-subtitle" />
                  </div>
                  <div className="admin-dashboard-skeleton-timeline">
                    {renderDashboardTimelineItems()}
                  </div>
                </div>
              </div>

              <div className="dashboard-sidebar">
                <div className="stats-card admin-dashboard-skeleton-card activity-card">
                  <div className="admin-dashboard-skeleton-card-title" />
                  <div className="admin-dashboard-skeleton-activity-list">
                    {renderDashboardActivityItems()}
                  </div>
                </div>
              </div>
            </div>
          </>
        );
      case 'services':
        return (
          <>
            <div className="services-toolbar admin-skeleton-services-toolbar">
              <div className="search-box">
                <div className="admin-skeleton-input admin-skeleton-input-lg admin-skeleton-fill" />
              </div>
              <div className="admin-skeleton-services-count" />
            </div>
            <div className="services-list admin-skeleton-services-list">
              {renderServiceRows()}
            </div>
          </>
        );
      case 'calendar':
        return (
          <>
            <div className="calendar-view admin-skeleton-calendar-view">
              <div className="admin-skeleton-calendar-toolbar">
                <div className="admin-skeleton-calendar-toolbar-group">
                  <div className="admin-skeleton-calendar-button" />
                  <div className="admin-skeleton-calendar-button" />
                  <div className="admin-skeleton-calendar-button admin-skeleton-calendar-button-wide" />
                </div>
                <div className="admin-skeleton-calendar-title" />
                <div className="admin-skeleton-calendar-toolbar-group">
                  <div className="admin-skeleton-calendar-button admin-skeleton-calendar-button-wide" />
                  <div className="admin-skeleton-calendar-button admin-skeleton-calendar-button-wide" />
                </div>
              </div>
              <div className="admin-skeleton-calendar-shell">
                <div className="admin-skeleton-calendar-head">
                  {renderBlocks(7, 'admin-skeleton-calendar-head-cell')}
                </div>
                <div className="admin-skeleton-calendar-grid">
                  {renderBlocks(21, 'admin-skeleton-calendar-slot')}
                </div>
              </div>
            </div>
          </>
        );
      case 'gallery':
        return (
          <>
            <div className="table-container">
              <div className="admin-gallery-upload admin-skeleton-gallery-upload">
                <div className="admin-skeleton-gallery-upload-copy">
                  <div className="admin-skeleton-gallery-upload-title" />
                  <div className="admin-skeleton-gallery-upload-subtitle" />
                </div>
                <div className="admin-skeleton-gallery-upload-actions">
                  <div className="admin-skeleton-gallery-file-button" />
                  <div className="admin-skeleton-gallery-file-meta" />
                </div>
              </div>
            </div>
            <div className="admin-skeleton-panel admin-skeleton-gallery-panel">
              <div className="admin-skeleton-table-head admin-skeleton-gallery-head">
                {renderBlocks(5, 'admin-skeleton-head-cell')}
              </div>
              <div className="admin-skeleton-gallery-body">
                {renderGalleryRows()}
              </div>
            </div>
          </>
        );
      case 'users':
        return (
          <>
            <div className="filters-section admin-skeleton-users-filters">
              <div className="search-box">
                <div className="admin-skeleton-input admin-skeleton-input-lg admin-skeleton-fill" />
              </div>
              <div className="filter-tabs admin-skeleton-filter-tabs">
                {renderBlocks(3, 'admin-skeleton-chip')}
              </div>
            </div>
            <div className="admin-skeleton-panel admin-skeleton-users-panel">
              <div className="admin-skeleton-table-head admin-skeleton-users-head">
                {renderBlocks(9, 'admin-skeleton-head-cell')}
              </div>
              <div className="admin-skeleton-users-body">
                {renderUserRows()}
              </div>
            </div>
          </>
        );
      case 'reservations':
        return (
          <>
            <div className="smart-tabs">
              <div className="tabs-container admin-skeleton-tabs admin-skeleton-reservations-tabs">
                {renderBlocks(5, 'admin-skeleton-tab')}
              </div>
            </div>
            <div className="advanced-filters admin-skeleton-reservations-filters">
              <div className="filter-row">
                <div className="admin-skeleton-input admin-skeleton-input-xl admin-skeleton-fill" />
                <div className="admin-skeleton-input admin-skeleton-fill" />
                <div className="admin-skeleton-input admin-skeleton-fill" />
                <div className="admin-skeleton-input admin-skeleton-fill" />
                <div className="admin-skeleton-input admin-skeleton-fill" />
              </div>
            </div>
            <div className="admin-skeleton-panel admin-skeleton-reservations-panel">
              <div className="admin-skeleton-table-head admin-skeleton-reservations-head">
                {renderBlocks(8, 'admin-skeleton-head-cell')}
              </div>
              <div className="admin-skeleton-reservations-body">
                {renderReservationRows()}
              </div>
            </div>
          </>
        );
      case 'table':
      default:
        return (
          <>
            <div className="admin-skeleton-toolbar">
              <div className="admin-skeleton-input admin-skeleton-input-lg" />
              <div className="admin-skeleton-input" />
              <div className="admin-skeleton-input" />
            </div>
            <div className="admin-skeleton-panel">
              <div className="admin-skeleton-table-head">
                {renderBlocks(5, 'admin-skeleton-head-cell')}
              </div>
              <div className="admin-skeleton-table-body">
                {renderTableRows(5)}
              </div>
            </div>
          </>
        );
    }
  };

  return (
    <div className={`admin-page admin-page-skeleton admin-page-skeleton-${variant}`} aria-hidden="true">
      <div className="page-header">
        <div>
          <h1>{title}</h1>
          <p className="text-muted">{subtitle}</p>
        </div>
        {showAction && <div className="admin-skeleton-button" />}
      </div>
      {renderVariant()}
    </div>
  );
};

export default AdminPageSkeleton;
